module.exports = __webpack_public_path__ + "img/qb-1x.0853c5b4.png";